// Beton Mock Data
// Hazır beton siparişleri, sevkiyatlar ve döküm takibi

export const betonSiparisler = [
    {
        id: 'bt-001',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Atlas Hazır Beton',
        tedarikciFirmaId: 'f-001',
        miktar: 75,
        birim: 'm³',
        sinif: 'C30/37',
        birimFiyat: 2800,
        toplamFiyat: 210000,
        durum: 'teslim',
        sevkiyatNo: 'SV-2026-001',
        dokumYeri: 'A Blok',
        pompaTipi: '42m Bom',
        insaatId: 'c1',
        not: 'Temel döküm tamamlandı',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-11T16:00:00Z',
    },
    {
        id: 'bt-002',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-13',
        tedarikci: 'Atlas Hazır Beton',
        tedarikciFirmaId: 'f-001',
        miktar: 50,
        birim: 'm³',
        sinif: 'C30/37',
        birimFiyat: 2800,
        toplamFiyat: 140000,
        durum: 'teslim',
        sevkiyatNo: 'SV-2026-002',
        dokumYeri: 'A Blok',
        pompaTipi: '42m Bom',
        insaatId: 'c1',
        not: 'Perde beton döküm',
        createdAt: '2026-01-12T09:00:00Z',
        updatedAt: '2026-01-13T15:30:00Z',
    },
    {
        id: 'bt-003',
        siparisTarihi: '2026-01-15',
        teslimTarihi: '2026-01-16',
        tedarikci: 'Akdeniz Beton',
        tedarikciFirmaId: 'f-002',
        miktar: 120,
        birim: 'm³',
        sinif: 'C35/45',
        birimFiyat: 3200,
        toplamFiyat: 384000,
        durum: 'teslim',
        sevkiyatNo: 'SV-2026-003',
        dokumYeri: 'A Blok',
        pompaTipi: '52m Bom',
        insaatId: 'c1',
        not: 'Döşeme beton dökümü, kür uygulandı',
        createdAt: '2026-01-15T07:00:00Z',
        updatedAt: '2026-01-16T18:00:00Z',
    },
    {
        id: 'bt-004',
        siparisTarihi: '2026-01-18',
        teslimTarihi: null,
        tedarikci: 'Atlas Hazır Beton',
        tedarikciFirmaId: 'f-001',
        miktar: 80,
        birim: 'm³',
        sinif: 'C30/37',
        birimFiyat: 2850,
        toplamFiyat: 228000,
        durum: 'bekliyor',
        sevkiyatNo: null,
        dokumYeri: 'A Blok',
        pompaTipi: '42m Bom',
        insaatId: 'c1',
        not: 'Yarın sabah 07:00 için planlı',
        createdAt: '2026-01-18T10:00:00Z',
        updatedAt: '2026-01-18T10:00:00Z',
    },
    {
        id: 'bt-005',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-09',
        tedarikci: 'Mega Beton',
        tedarikciFirmaId: 'f-003',
        miktar: 45,
        birim: 'm³',
        sinif: 'C25/30',
        birimFiyat: 2600,
        toplamFiyat: 117000,
        durum: 'teslim',
        sevkiyatNo: 'SV-2026-005',
        dokumYeri: 'B Blok',
        pompaTipi: '36m Bom',
        insaatId: 'c2',
        not: 'Temel beton dökümü',
        createdAt: '2026-01-08T08:30:00Z',
        updatedAt: '2026-01-09T14:00:00Z',
    },
];

// Beton sınıfları
export const betonSiniflari = [
    { key: 'C25/30', label: 'C25/30', aciklama: 'Normal mukavemet' },
    { key: 'C30/37', label: 'C30/37', aciklama: 'Yüksek mukavemet' },
    { key: 'C35/45', label: 'C35/45', aciklama: 'Çok yüksek mukavemet' },
    { key: 'C40/50', label: 'C40/50', aciklama: 'Özel projeler' },
];

// Pompa tipleri
export const pompaTipleri = [
    { key: '36m', label: '36m Bom' },
    { key: '42m', label: '42m Bom' },
    { key: '52m', label: '52m Bom' },
    { key: '58m', label: '58m Bom' },
];

// İstatistikler
export const getBetonStats = (insaatId) => {
    const filtered = insaatId
        ? betonSiparisler.filter(s => s.insaatId === insaatId)
        : betonSiparisler;

    const toplamSiparis = filtered.reduce((acc, s) => acc + s.miktar, 0);
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.miktar, 0);
    const bekleyen = filtered.filter(s => s.durum === 'bekliyor').reduce((acc, s) => acc + s.miktar, 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return {
        toplamSiparis,
        teslimEdilen,
        bekleyen,
        toplamMaliyet,
        siparisAdedi: filtered.length,
    };
};

// Helper: insaata göre filtrele
export const getBetonByInsaat = (insaatId) => {
    if (!insaatId) return betonSiparisler;
    return betonSiparisler.filter(s => s.insaatId === insaatId);
};
